import { MARQUEE } from "@/lib/content";

const Arch = () => (
  <svg viewBox="0 0 20 24" className="mx-10 h-6 w-5 shrink-0" aria-hidden="true">
    <path d="M2 23V10a8 8 0 0 1 16 0v13" fill="none" stroke="#B39158" strokeWidth="1.2" />
  </svg>
);

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#3D5A4C]/15 bg-[#F3EFE8] py-7 sm:py-9">
      <div className="marquee-track flex w-max items-center">
        {items.map((m, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-serif-d whitespace-nowrap text-3xl sm:text-5xl ${i % 2 ? "italic text-[#3D5A4C]" : "font-light text-[#1C2826]"}`}>{m}</span>
            <Arch />
          </span>
        ))}
      </div>
    </div>
  );
};
